var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { useCallback, useEffect, useRef, useState } from "react";
import { Span } from "./span";
import { useSize } from "../utils/use-size";

var SVGFont = function (_a) {
  var children = _a.children,
      styles = _a.styles;
  var SVGRef = useRef(null);

  var _b = useState({
    width: 0,
    height: 0
  }),
      bound = _b[0],
      setBound = _b[1];

  var size = useSize(SVGRef);
  var getBox = useCallback(function () {
    var _a, _b;

    return (_b = (_a = SVGRef.current) === null || _a === void 0 ? void 0 : _a.getBBox) === null || _b === void 0 ? void 0 : _b.call(_a);
  }, []);
  var resetSVG = useCallback(function (xy) {
    if (xy === void 0) {
      xy = true;
    }

    var svg = getBox();
    setBound({
      width: Math.ceil(svg === null || svg === void 0 ? void 0 : svg.width),
      height: Math.ceil(svg === null || svg === void 0 ? void 0 : svg.height)
    });
  }, []);
  useEffect(function () {
    resetSVG(false);
  }, [size]);
  useEffect(function () {
    document.fonts.ready.then(function () {
      resetSVG(true);
    });
    return function () {
      SVGRef.current = null;
    };
  }, []);
  useEffect(function () {
    resetSVG(false);
  }, [children]);
  return React.createElement(React.Fragment, null, React.createElement("svg", {
    width: (bound === null || bound === void 0 ? void 0 : bound.width) || 0,
    height: (bound === null || bound === void 0 ? void 0 : bound.height) || 0,
    ref: SVGRef,
    style: __assign({}, styles)
  }, React.createElement("text", {
    x: "0",
    y: Math.ceil(Math.abs(((bound === null || bound === void 0 ? void 0 : bound.height) || 0) / 1.15)) || 0,
    style: {
      lineHeight: 1.15
    }
  }, children)));
};

SVGFont.Span = Span;
export { SVGFont };